module.exports = __webpack_public_path__ + "img/LV1.9436429a.webp";